export default {
  server: {
    baseUrl: "http://72.60.201.22:3000",
  },
}
